import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import {  Cookies } from 'react-cookie';

import AllMarketerRequests from "./AllMarketerRequests";
import MyMarketerRequests from "./MyMarketerRequests";
import IssuanceMarketerRequests from "./IssuanceMarketerRequests";
import RenewalMyMarketerRequests from "./RenewalMyMarketerRequests";
import OtherMyMarketerRequests from "./OtherMyMarketerRequests";
import ReturnedMarketerRequests from "./ReturnedMarketerRequests";
import PaidMyMarketerRequests from "./PaidMyMarketerRequests";
import PoyaMarketerRequests from "./PoyaMarketerRequests";



const styles = theme => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }
    , paper: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },


});

class MarketersPanel extends Component {
    cookies=new Cookies();
    constructor(props) {
        super(props);
        this.state = {
            value:0,
        }}

    componentDidMount() {

    }
    handleChange= (event,newValue) => {
        this.setState({ value:newValue });
    }
    render() {
        const { classes } = this.props;
        const { value } = this.state;

        return (
            <div>
                <AppBar position="sticky"color="primary" >

                    <Tabs
                        style={{height:'60px',textAlign:'center'}}
                        value={value}
                        onChange={this.handleChange}
                        indicatorColor="secondary"
                        textColor={'#000000'}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                    >

                        <Tab label="در حال بررسی"/>
                        <Tab label="بانک درخواست ها"/>
                        <Tab label="پرداخت شده"/>
                        <Tab label="برگشتی ها"/>
                        <Tab label="تمدیدی ها"/>
                        <Tab label="سایر(فروخته شد - سایر ..)"/>
                        <Tab label="پویا"/>


                    </Tabs>


                </AppBar>

                {(value===0)?<MyMarketerRequests  props={this.props}/>:null}
                {(value===1)?<AllMarketerRequests  props={this.props}/>:null}
                {(value===2)?<PaidMyMarketerRequests  props={this.props}/>:null}
                {(value===3)?<ReturnedMarketerRequests  props={this.props}/>:null}
                {(value===4)?<RenewalMyMarketerRequests  props={this.props}/>:null}
                {(value===5)?<OtherMyMarketerRequests  props={this.props}/>:null}
                {(value===6)?<PoyaMarketerRequests  props={this.props}/>:null}




            </div>
        );
    }
}

export default  withStyles(styles)(MarketersPanel);
